import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import BzmIcon from '../../icons/BzmIcon';

export type RunnerTypes = 'httpRunner' | 'messagingRunner' | 'websocketRunner';

interface Props {
  activeRunner: RunnerTypes;
  onRunnerChanged: (tab: RunnerTypes) => void;
  className?: string;
}

const RunnersButtonGroup = ({ activeRunner, onRunnerChanged, className }: Props) => {
  return (
    <ButtonGroup className={className}>
      <Button
        key={'httpRunner'}
        onClick={() => {
          onRunnerChanged('httpRunner');
        }}
        variant={activeRunner === 'httpRunner' ? 'primary' : 'secondary'}
      >
        <BzmIcon variant={'icon-bzm-http'} />
        <span className="ml-2">HTTP Runner</span>
      </Button>
      <Button
        key={'messagingRunner'}
        onClick={() => {
          onRunnerChanged('messagingRunner');
        }}
        variant={activeRunner === 'messagingRunner' ? 'primary' : 'secondary'}
      >
        <BzmIcon variant={'icon-bzm-stacked-email'} />
        <span className="ml-2">Messaging Runner</span>
      </Button>
    </ButtonGroup>
  );
};

export default RunnersButtonGroup;
